import Section1 from './SectionManager/Section1';
import Section3 from './SectionManager/Section3';
import Section8 from './SectionManager/Section8';
import SectionPartner from './SectionManager/SectionPartner';
import SectionWhyBookUs from './SectionManager/SectionWhyBookUs';
import SectionFamousToRoute from './SectionManager/SectionFamousToRoute';
import Section13 from './SectionManager/Section13';
import VNTicket from './SectionManager/VNTicket';
import VJTicket from './SectionManager/VJTicket';
import QHTicket from './SectionManager/QHTicket';
import SearchInput from './SectionManager/SearchInput';
import VUTicket from './SectionManager/VUTicket';
import BLTicket from './SectionManager/BLTicket';
import Section9 from '@/components/RoutePage/SectionManager/Section9';

export const MENU_BAR = [
  { label: 'Tìm chuyến' },
  { label: 'Săn vé' },
  { label: 'Vé Tết' },
  { label: 'Thông tin' },
];

export const CONTENT_SECTION = {
  section1: {
    isNewYear: false,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: 'Săn vé máy bay giá rẻ {{route_name}}',
      component: 'h2',
      fontSize: '22px',
    },
    title2: {
      vi: 'Vé máy bay {{route_name}} Vietnam Airlines, Vietjet Air, Jestar, Bamboo ngày hôm nay',
      component: 'h3',
    },
    note: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    note2: {
      vi: 'Giá vé có thể thay đổi tùy thuộc vào thời gian đặt vé và hạng ghế được chọn',
    },
    description: {
      vi: `
      Chuyến bay giá rẻ nhất từ các tỉnh thành {{route_name}} ngày {{route_now}}
      <br/><br/>
      Bấm vào mỗi ngày để đặt mua ngay các vé máy bay của hãng mà bạn thích nhất`,
    },
    component: Section13,
  },
  section110: {
    isNewYear: false,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: 'Mẹo săn vé giá rẻ {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Thời điểm Covid thì bạn có thể mua vé gần ngày đi vì giá vẫn thấp. Nhu cầu đi lại của mọi người vẫn chưa cao nên tỉ lệ lấp đầy của hãng cũng không cao dẫn đến giá sẽ không cao như các năm trước. Tuy nhiên thị trường đang dần hồi phục nên các đợt cao điểm như Lễ, Tết thì giá vẫn rất cao vì cung không đủ cầu.
      <div style='margin-top:10px'></div>
      Mẹo để săn vé rẻ nhất là bạn nên book vé sớm trước vài tuần bằng cách xem lịch ở trang chủ của Goyolo.com. Chúng tôi liệt kê sẵn giá tất cả các ngày trong tháng với những ngày nào giá thấp nhất giữa tất cả các hãng bay được tô đậm như hình bên trên. Bạn chọn ngày nào có giá tốt nhất và phù hợp lịch di chuyển của bạn.`,
    },
    component: null,
  },
  sectionSearchInput: {
    isNewYear: true,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: 'Bảng giá vé máy bay {{route_name}} trong tháng {{route_month}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [],
    },
    description: {
      vi: 'Nhập điểm đi mong muốn để xem giá vé máy bay rẻ nhất trong tháng {{route_name}}',
    },
    component: SearchInput,
  },
  section2: {
    isNewYear: false,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: '',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: Section3,
  },
  sectionSearchInput2: {
    isNewYear: true,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: 'Săn vé máy bay giá rẻ nhất {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [],
    },
    description: {
      vi: 'Nhập điểm đi mong muốn để xem giá vé máy bay rẻ nhất trong tháng {{route_name}}',
    },
    bottomText: {
      vi: 'Bấm vào ngày để xem ngay các giờ bay có giá cực rẻ đi Hà Nội',
    },
    component: SearchInput,
  },
  section3: {
    isNewYear: false,
    id: 'san-ve',
    isHaveDivider: true,
    style: {
      position: 'relative',
      top: '-20px',
    },
    title: {
      vi: '',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },

    component: Section1,
  },
  section4: {

    isNewYear: false,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: 'Mẹo săn vé giá rẻ {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Thời điểm Covid thì bạn có thể mua vé gần ngày đi vì giá vẫn thấp. Nhu cầu đi lại của mọi người vẫn chưa cao nên tỉ lệ lấp đầy của hãng cũng không cao dẫn đến giá vé máy bay {{route_name}} sẽ không cao như các năm trước. Tuy nhiên thị trường đang dần hồi phục nên các đợt cao điểm như Lễ, Tết thì giá vé đến {{to_name}} vẫn rất cao vì cung không đủ cầu.
      <div style='margin-top:10px'></div>
      Mẹo để săn vé máy bay {{route_name}} rẻ nhất là bạn nên book vé sớm trước vài tuần bằng cách xem lịch ở trang chủ của Goyolo.com. Chúng tôi liệt kê sẵn giá tất cả các ngày trong tháng với những ngày nào giá thấp nhất giữa tất cả các hãng bay được tô đậm như hình bên trên. Bạn chọn ngày nào có giá tốt nhất và phù hợp lịch di chuyển của bạn.
      <div style='margin-bottom:25px'></div>
      `,
    },
    component: null,
  },
  sectionSearchInput3: {
    isDivider: true,
    isNewYear: true,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: 'Vé máy bay giá rẻ Tết {{luna_year}} {{route_name}}',
      component: 'h3',
      fontSize: '22px',
      style: {
        marginTop: '20px',
      },
    },
    title2: {
      vi: 'Đặt mua vé máy bay Tết {{luna_year}} giá rẻ nhất',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [],
    },
    description: {
      vi: `
      Vé máy bay {{route_name}} tết {{luna_year}} đã mở bán từ các hãng Vietnam Airlines, Vietjet Air, Bamboo Airways, Jetstar với mức giá cực hấp dẫn.
      <div style='margin-bottom:10px'></div> 
      Nhập điểm đi mong muốn để xem giá vé máy bay rẻ nhất {{route_name}}.`,
    },
    component: SearchInput,
  },
  section6: {
    isNewYear: true,
    id: 've-tet',
    isHaveDivider: true,
    style: {
      position: 'relative',
      top: '-25px',
    },
    title: {
      vi: '',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [
        'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn.',
        'Thời gian khởi hành theo giờ địa phương.',
        'Giá vé có thể thay đổi tùy thuộc vào thời gian đặt vé và hạng ghế được chọn.',
      ],
    },
    description: {
      vi: `
      `,
    },
    component: Section8,
  },
  sectionSearchInput4: {
    isNewYear: true,
    id: 'san-ve',
    isHaveDivider: true,
    title: {
      vi: 'Bảng giá vé máy bay Tết {{luna_year}} {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [],
    },
    description: {
      vi: 'Chọn điểm đi mong muốn để xem giá vé máy bay rẻ nhất trong tháng {{route_name}}',
    },
    component: SearchInput,
  },
  section7: {
    isNewYear: true,
    id: 've-tet',
    isHaveDivider: true,
    style: {
      position: 'relative',
      top: '-15px',
    },
    title: {
      vi: '',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: Section9,
  },
  SectionParner: {
    isDivider: true,
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Hơn 1500+ đối tác của Goyolo.com',
      component: 'h3',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionPartner,
  },
  sectionVN: {
    isNewYear: false,
    isDivider: true,
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Vé máy bay Vietnam Airlines {{route_name}}',
      airline: 'Vietnam Airlines',
      component: 'a',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Đặt vé liền tay để có những chuyến bay giá thấp nhất của Vietnam Airlines {{route_name}} ngày hôm nay. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh.',
    },
    component: VNTicket,
  },
  sectionVJ: {
    isNewYear: false,
    isDivider: true,
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Vé máy bay VietJet Air {{route_name}}',
      airline: 'VietJet Air',
      component: 'p',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Đặt vé liền tay để có những chuyến bay giá thấp nhất của VietJet Air {{route_name}} ngày hôm nay. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh.',
    },
    component: VJTicket,
  },
  sectionQH: {
    isNewYear: false,
    isDivider: true,
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Vé máy bay Bamboo Airways {{route_name}}',
      airline: 'Bamboo Airways',
      component: 'p',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Đặt vé liền tay để có những chuyến bay giá thấp nhất của Bamboo Airways {{route_name}} ngày hôm nay. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh.',
    },
    component: QHTicket,
  },
  sectionVU: {
    isNewYear: false,
    isDivider: true,
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Vé máy bay Vietravel Airlines {{route_name}}',
      airline: 'Vietravel Airlines',
      component: 'p',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Đặt vé liền tay để có những chuyến bay giá thấp nhất của Vietravel Airlines {{route_name}} ngày hôm nay. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh.',
    },
    component: VUTicket,
  },
  sectionBL: {
    isNewYear: false,
    isDivider: true,
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Vé máy bay Pacific Airlines {{route_name}}',
      airline: 'Pacific Airlines',
      component: 'p',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Đặt vé liền tay để có những chuyến bay giá thấp nhất của Pacific Airlines {{route_name}} ngày hôm nay. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh.',
    },
    component: BLTicket,
  },
  SectionFamousToRoute: {
    id: 'thong-tin',
    isDivider: true,
    isHaveDivider: true,
    title: {
      vi: 'Chặng bay phổ biến đến {{to_name}}',
      component: 'h3',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionFamousToRoute,
  },
  SectionWhyBookUs: {
    id: 'thong-tin',
    isDivider: true,
    isHaveDivider: true,
    title: {
      vi: 'Tại sao bạn nên đặt vé qua Goyolo.com',
      component: 'h3',
      style: {
        marginTop: '20px',
      },
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionWhyBookUs,
  },
};

export const metaFaqJson = `
{
  "@context": "https://schema.org",
  "@type": "QAPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "Tôi có thể tìm vé máy bay {{route_name}} khuyến mãi như thế nào?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Bạn có thể tìm kiếm chương trình khuyến mãi tại mục 'Mẹo săn vé máy bay giá rẻ {{route_name}}' hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com."
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể mua vé máy bay {{route_name}} 247 qua Goyolo.com được không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chúng tôi hoạt động tất cả các ngày kể cả thứ 7, chủ nhật và ngày Lễ, Tết bạn có thể đặt vé bất cứ khi nào có nhu cầu."
    }
  },{
    "@type": "Question",
    "name": "Trẻ em và trẻ sơ sinh đi máy bay cần những giấy tờ gì?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Đối với trẻ em khi đi máy bay đều sẽ cần có giấy khai sinh bản chính hoặc công chứng, ngoài ra hãng còn yêu cầu trẻ em phải có đủ sức khỏe để được tham gia chuyến bay. Sẽ có một tiếp viên hàng không hoặc người thân trên 18 tuổi đi cùng bé, trẻ em sẽ được sử dụng các dịch vụ trên chuyến bay trong vòng 24 giờ. Với trường hợp trẻ sơ sinh đi máy bay thì sẽ bắt buộc cần giấy khai sinh để làm mọi thủ tục liên quan trước khi cất cánh và đặc biệt sẽ có phụ huynh theo kèm bé."
    }
  },{
    "@type": "Question",
    "name": "Goyolo.com có bán vé máy bay Tết {{route_name}} năm nay không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Goyolo.com có mở bán vé máy bay Tết và cả Vé xe khách của các thương hiệu uy tín {{route_name}}, với mức giá ưu đãi nhất."
    }
  },{
    "@type": "Question",
    "name": "{{route_name}} quy định an toàn Covid-19 như thế nào khi bay?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Khi đi máy bay {{route_name}}, hành khách phải tuân thủ các quy định sau để đảm bảo an toàn Covid-19:
      
      Thực hiện khai báo y tế trên ứng dụng PC-COVID (Theo công văn số 1887/BGTVT-CYT của Bộ Giao thông Vận tải ngày 28/10/2021)
      Không được tham gia chuyến bay khi có các triệu chứng ho, sốt, khó thở, đau mỏi cơ, đau rát họng, mất vị giác,…
      Luôn đeo khẩu trang, sát khuẩn tay, hạn chế tiếp xúc trước, trong và sau chuyến bay
      Trong quá trình di chuyển từ Cảng hàng không về nơi cư trú luôn thực hiện 5K, hạn chế dừng và không tiếp xúc nơi đông người
      Chủ động thông báo với chính quyền địa phương nơi cư trú, lưu trú
      Tự theo dõi sức khoẻ và thực hiện theo quy định cụ thể của từng địa phương về các biện pháp phòng chống dịch COVID-19 kể từ ngày về địa phương
      Trường hợp có dấu hiệu bất thường về sức khoẻ như ho, sốt, khó thở, đau rát họng, mất vị giác…thông báo ngay cho cơ quan y tế để theo dõi và triển khai quy trình xử lý dịch bệnh theo quy định."
    }
  },{
    "@type": "Question",
    "name": "Tôi mua vé máy bay {{route_name}} thì có được hoàn huỷ không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chính sách và phí hoàn hủy vé thay đổi tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách hoàn vé hay huỷ vé. Theo kinh nghiệm hoàn huỷ vé máy bay, trong các đợt Tết, quy định hoàn huỷ vé thường sẽ thay đổi. Nếu bạn huỷ vé càng sớm, chính sách huỷ sẽ càng tốt và số tiền bạn được hoàn lại sẽ cao. Lưu ý, trong một số trường hợp, bạn không thể hoàn huỷ vé ngay sát giờ khởi hành.
      Đối với các trường hợp hoàn huỷ vé vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách hoàn huỷ vé tạo điều kiện hỗ trợ tối đa cho hành khách.
      Để biết chính sách cụ thể về điều kiện huỷ, bạn vui lòng tham khảo tại mục 'Chính sách và phí hoàn hủy vé' của từng hãng."
    }
  },{
    "@type": "Question",
    "name": "Tôi có được đổi ngày giờ bay khi đặt vé máy bay {{route_name}} không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chính sách và phí đổi giờ bay, ngày bay thay đổi tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách thay đổi ngày giờ bay. Theo kinh nghiệm đổi vé máy bay, trong các đợt Tết, quy định đổi vé thường sẽ thay đổi. Nếu bạn đổi chuyến bay càng sớm, chính sách đổi sẽ càng tốt. Lưu ý, trong một số trường hợp, bạn không thể đổi vé ngay sát giờ khởi hành.
      Đối với các trường hợp đổi ngày giờ bay vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách đổi vé tạo điều kiện hỗ trợ tối đa cho hành khách.
      Để biết chính sách cụ thể về điều kiện đổi chuyến bay, bạn vui lòng tham khảo tại mục 'Chính sách và phí đổi ngày, giờ bay' của từng hãng."
    }
  }]
}
`;

export const FAQ = [
  {
    id: 1,
    title: 'Giá vé máy bay ngày hôm nay {{route_name}}',
    content:
      'Hiện tại giá vé đi {{to_name}} thấp nhất là từ {{min_fare}}, khởi hành lúc {{latest_pickup_time}} giờ và vận hành bởi {{route_airline}}.',
    onClick: '',
  },
  {
    id: 2,
    title: 'Chuyến bay {{route_name}} khởi hành sớm nhất hôm nay?',
    content:
      'Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} có khởi hành sớm nhất là lúc {{latest_pickup_time}} giờ, được vận hành bởi {{route_airline}}.',
    onClick: '',
  },
  {
    id: 3,
    title: 'Chuyến bay {{route_name}} khởi hành trễ nhất hôm nay?',
    content:
      'Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} có khởi hành trễ nhất là lúc {{latest_pickup_time}} giờ, được vận hành bởi {{route_airline}}.',
    onClick: '',
  },
  {
    id: 4,
    title: 'Tôi có thể tìm vé máy bay {{route_name}} khuyến mãi như thế nào?',
    content:
      'Bạn có thể tìm kiếm chương trình khuyến mãi tại mục "Mẹo săn vé máy bay giá rẻ {{route_name}} hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com.',
    onClick: '',
  },
  {
    id: 5,
    title:
      'Tôi có thể mua vé máy bay đi {{to_name}} 247 qua Goyolo.com được không?',
    content:
      'Chúng tôi hoạt động tất cả các ngày kể cả thứ 7, chủ nhật và ngày Lễ, Tết bạn có thể đặt vé bất cứ khi nào có nhu cầu.',
    onClick: '',
  },
  {
    id: 6,
    title: 'Goyolo.com có bán vé máy bay Tết đi {{to_name}} năm nay không?',
    content:
      'Goyolo.com có mở bán vé máy bay Tết và cả Vé xe khách của các thương hiệu uy tín {{route_name}}, với mức giá ưu đãi nhất.',
    onClick: '',
  },
  {
    id: 7,
    title: 'Tôi có thể tìm vé máy bay {{route_name}} khuyến mãi như thế nào?',
    content:
      'Bạn có thể tìm kiếm chương trình khuyến mãi tại mục "Mẹo săn vé máy bay giá rẻ {{route_name}} hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com.',
    onClick: '',
  },
  {
    id: 8,
    title: 'Tôi có thể hủy chuyến bay {{route_name}} không?',
    content: `
    Chính sách và phí hoàn hủy vé cho chuyến bay {{route_name}} thay đổi tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách hoàn vé hay hủy vé.<br/>
    Theo kinh nghiệm hoàn hủy vé máy bay, trong các đợt Tết, quy định hoàn hủy vé thường sẽ thay đổi. Nếu bạn hủy vé càng sớm, chính sách hủy sẽ càng tốt và số tiền bạn được hoàn lại sẽ cao. Lưu ý, trong một số trường hợp, bạn không thể hoàn hủy vé ngay sát giờ khởi hành.<br/>
    Đối với các trường hợp hoàn hủy vé vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách hoàn hủy vé tạo điều kiện hỗ trợ tối đa cho hành khách.<br/>
    Để biết chính sách cụ thể về điều kiện hủy vé, bạn vui lòng tham khảo theo từng hãng bay:
    <ul>
      <li>
        <a href=/vn/ve-may-bay/vietnam-airlines.vi>Vietnam Airlines</a> 
      </li> 
      <li>
        <a href=/vn/ve-may-bay/vietjet-air.vi>Vietjet Air </a>
      </li>
      <li>
        <a href=/vn/ve-may-bay/bamboo-airways.vi>Bamboo Airways </a>
      </li>
    </ul>
    `,
    onClick: '',
  },
  {
    id: 9,
    title: 'Tôi có thể đổi ngày giờ chuyến bay {{route_name}} không?',
    content: `
    Chính sách và phí đổi giờ bay, ngày bay cho chuyến bay {{route_name}} khác nhau tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách thay đổi ngày giờ bay.
    Theo kinh nghiệm đổi vé máy bay, trong các đợt Tết, quy định đổi vé thường sẽ thay đổi. Nếu bạn đổi chuyến bay càng sớm, chính sách đổi sẽ càng tốt. Lưu ý, trong một số trường hợp, bạn không thể đổi vé ngay sát giờ khởi hành.
    Đối với các trường hợp đổi ngày giờ bay vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách đổi vé tạo điều kiện hỗ trợ tối đa cho hành khách.
    Để biết chính sách cụ thể về điều kiện đổi chuyến bay, bạn vui lòng tham khảo theo từng hãng bay:
    <ul>
      <li>
        <a href=/vn/ve-may-bay/vietnam-airlines.vi>Vietnam Airlines</a> 
      </li> 
      <li>
        <a href=/vn/ve-may-bay/vietjet-air.vi>Vietjet Air </a>
      </li>
      <li>
        <a href=/vn/ve-may-bay/bamboo-airways.vi>Bamboo Airways </a>
      </li>
    </ul>
    `,
    onClick: '',
  },
  {
    id: 10,
    title: 'Giá vé của Goyolo.com đã bao gồm thuế và phụ phí chưa?',
    content: `
    Giá vé máy bay trên Goyolo.com đã bao gồm tất cả các khoảng thuế, phụ phí, phí cổng thanh toán và là số tiền cuối cùng bạn thanh toán. Nếu bạn thấy giá chênh lệch giữa Goyolo.com với giá vé hiển thị tại hãng bay hay đại lý khác, thường là do giá vé hiển thị ở những nơi này chưa bao gồm thuế, phí, phí cổng thanh toán.`,
    onClick: '',
  },
];
